import { jsx, jsxs } from 'react/jsx-runtime';
import { getWalletLinks, WalletIcon, getWalletBookWallet } from '@dynamic-labs/wallet-book';
import 'react';
import { Typography } from '../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../components/IconButton/IconButton.js';
import { getBrowserIcon } from '../../shared/utils/functions/getBrowserIcon/getBrowserIcon.js';
import { WalletHelpLink } from './WalletHelpLink.js';

const NoQrNotInstalledView = () => {
    const { selectedWalletConnector } = useInternalDynamicContext();
    if (!selectedWalletConnector) {
        return null;
    }
    const downloadLinks = Object.entries(getWalletLinks(selectedWalletConnector.name))
        .filter(([, link]) => link !== '')
        .filter(([name]) => name !== 'ios' && name !== 'android')
        .map(([name, link]) => (jsx(WalletHelpLink, { name: name, link: link, 
        // justification: we're looping over the keys of walletLinks.desktop
        Icon: getBrowserIcon(name) }, name)));
    return (jsxs("div", Object.assign({ className: 'no-qr-code-installed__container', "data-testid": 'no-qr-code-installed' }, { children: [jsx("div", Object.assign({ className: 'no-qr-code-installed__img' }, { children: jsx(WalletIcon, { walletName: selectedWalletConnector.name, style: { height: pixelToRem(64), width: pixelToRem(64) } }) })), jsxs(Typography, Object.assign({ className: 'no-qr-code-installed__typography--title', variant: 'title' }, { children: ["Install ", getWalletBookWallet(selectedWalletConnector.name).name, ' ', "extension to connect"] })), jsx(Typography, Object.assign({ variant: 'body_normal', className: 'no-qr-code-installed__typography', color: 'secondary' }, { children: "Select from your preferred options below:" })), jsx("div", Object.assign({ className: 'no-qr-code-installed__links-section' }, { children: downloadLinks })), jsx(Typography, Object.assign({ variant: 'body_mini', className: 'no-qr-code-installed__typography', weight: 'medium', color: 'secondary' }, { children: "Refresh the page once installed" }))] })));
};

export { NoQrNotInstalledView };
